import { Box, Container, Grid, Typography } from '@mui/material';
import { FC } from 'react';
import developer from '../../assets/images/developer.png';
import { CheckCircleOutline } from '@mui/icons-material';
import { useInView } from '../../hooks/useInView';

const PRIMARY = '#8c7c0c';

const BENEFITS = [
    'Showcase developments to international buyers and investors',
    'Manage bookings and track project progress remotely',
    'Receive secure, transparent payments on one trusted platform',
    'Built-in marketing support to reach qualified buyers',
    'Connect with tenants and landlords across Kenya',
];

const Developer: FC = () => {
    const { ref, visible } = useInView();

    return (
        <Box
            component="section"
            id="developer"
            ref={ref}
            sx={{
                py: { xs: 8, md: 12 },
                background: 'linear-gradient(135deg, #f9f9f0 0%, #e8e4b0 100%)',
            }}
        >
            <Container maxWidth="lg">
                <Grid container spacing={{ xs: 6, md: 8 }} alignItems="center">
                    {/* Copy */}
                    <Grid item xs={12} md={6}>
                        <Box className={`sg-reveal-left ${visible ? 'sg-visible' : ''}`}>
                            <Typography sx={{ display: 'inline-block', bgcolor: `${PRIMARY}18`, color: PRIMARY, px: 2, py: 0.5, borderRadius: 20, fontSize: 13, fontWeight: 600, mb: 2 }}>
                                For Developers
                            </Typography>
                            <Typography component="h2" sx={{ fontSize: { xs: 30, md: 42 }, fontWeight: 800, color: '#111827', lineHeight: 1.2, mb: 2 }}>
                                Unlock Global Investment for Your Projects
                            </Typography>
                            <Typography sx={{ fontSize: 16, color: '#4b5563', lineHeight: 1.7, mb: 4 }}>
                                Sheltergram connects property developers with a network of global investors and buyers — making it easier to fund, market, and deliver real estate projects.
                            </Typography>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                                {BENEFITS.map((b) => (
                                    <Box key={b} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                                        <CheckCircleOutline sx={{ color: PRIMARY, fontSize: 20, mt: 0.2, flexShrink: 0 }} />
                                        <Typography sx={{ fontSize: 15, color: '#374151' }}>{b}</Typography>
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    </Grid>

                    {/* Image */}
                    <Grid item xs={12} md={6}>
                        <Box className={`sg-reveal-right ${visible ? 'sg-visible' : ''}`} sx={{ textAlign: 'center' }}>
                            <img
                                src={developer}
                                alt="Developer dashboard"
                                loading="lazy"
                                style={{ width: '100%', maxWidth: 440, objectFit: 'contain', filter: 'drop-shadow(0 16px 40px rgba(0,0,0,.12))' }}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default Developer;
